import { ContentButton } from '../content/button';
import { ContentIntro } from '../content/intro';

/**
 * Model definition for HouseholdCalculator
 */
export interface HouseholdCalculator {
  __component: 'forms.haushold-calculator';
  id: string;
  intro?: ContentIntro;
  cta?: ContentButton;
  adults: number;
  children: number;
  income: number;
  rentFlat: boolean;
  rent: number;
  livingCost: number;
  expenses: 'blanketValue' | 'properValue';
  cars: number;
  motorBikes: number;
  summary: string;
  headlineBottom: string;
}

export function isHouseholdCalculator(obj: { __component?: string }): obj is HouseholdCalculator {
  return obj.__component === 'forms.haushold-calculator';
}
